import clsx from "clsx";
import { Button, Typography } from "@material-ui/core";
import React from "react";
import { makeStyles } from "@material-ui/styles";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

const useStyles = makeStyles(() => ({
  navigation: {
    paddingTop: 24,
  },
  subheading: {
    margin: 10,
    textAlign: "center",
  },
  bold: {
    fontWeight: 550,
  },
  imgContainer: {
    paddingLeft: 40,
    paddingRight: 40,
    display: "inline-block",
  },
  icon: {
    display: "flex",
  },
  contactUsButtonContainer: {
    textAlign: "center",
    padding: 30,
  },
  container: {
    textAlign: "center",
    display: "inline-block",
  },
  innerContainer: {
    marginBottom: 10,
    display: "inline-block",
  },
  paragraphs: {
    textAlign: "left",
  },
}));

export const CohortsDisabledPage: React.FC = () => {
  // this components seems unreacheable

  const classes = useStyles();

  return (
    <>
      <Typography component="h2" gutterBottom variant="overline">
        Cohorts
      </Typography>
      <Typography component="h1" gutterBottom variant="h3">
        Sync user segments to your destinations.
      </Typography>
      <div className={clsx(classes.container)}>
        <div className={clsx(classes.innerContainer)}>
          <div className={clsx(classes.imgContainer)}>
            <Typography
              className={clsx(classes.subheading)}
              component="h1"
              gutterBottom
              variant="h2"
            >
              Cohorts are disabled. Reach out to us to enable.
            </Typography>
          </div>

          <div className={clsx(classes.contactUsButtonContainer)}>
            <a>
              <Button
                color="primary"
                variant="contained"
                href="https://support.freshpaint.io"
                target="_blank"
              >
                Contact Us
                <ChevronRightIcon className={classes.icon} />
              </Button>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};
